import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IPartenaire } from 'app/shared/model/partenaire.model';
import { getEntity, updateEntity, createEntity, reset } from './partenaire.reducer';

export const PartenaireUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const partenaireEntity = useAppSelector(state => state.partenaire.entity);
  const loading = useAppSelector(state => state.partenaire.loading);
  const updating = useAppSelector(state => state.partenaire.updating);
  const updateSuccess = useAppSelector(state => state.partenaire.updateSuccess);

  const handleClose = () => {
    navigate('/partenaire' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.tarifDeTransport !== undefined && typeof values.tarifDeTransport !== 'number') {
      values.tarifDeTransport = Number(values.tarifDeTransport);
    }
    values.datePersistence = convertDateTimeToServer(values.datePersistence);
    values.dateUpdate = convertDateTimeToServer(values.dateUpdate);

    const entity = {
      ...partenaireEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          datePersistence: displayDefaultDateTime(),
          dateUpdate: displayDefaultDateTime(),
        }
      : {
          ...partenaireEntity,
          datePersistence: convertDateTimeFromServer(partenaireEntity.datePersistence),
          dateUpdate: convertDateTimeFromServer(partenaireEntity.dateUpdate),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="alexisExportApp.partenaire.home.createOrEditLabel" data-cy="PartenaireCreateUpdateHeading">
            <Translate contentKey="alexisExportApp.partenaire.home.createOrEditLabel">Create or edit a Partenaire</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="partenaire-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('alexisExportApp.partenaire.nomOuRaisonSociale')}
                id="partenaire-nomOuRaisonSociale"
                name="nomOuRaisonSociale"
                data-cy="nomOuRaisonSociale"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('alexisExportApp.partenaire.tarifDeTransport')}
                id="partenaire-tarifDeTransport"
                name="tarifDeTransport"
                data-cy="tarifDeTransport"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('alexisExportApp.partenaire.datePersistence')}
                id="partenaire-datePersistence"
                name="datePersistence"
                data-cy="datePersistence"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('alexisExportApp.partenaire.dateUpdate')}
                id="partenaire-dateUpdate"
                name="dateUpdate"
                data-cy="dateUpdate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/partenaire" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PartenaireUpdate;
